


import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ResponsiveImageMedia } from '../ResponsiveImage/ResponsiveImage.models';
import loadImgSrc from '@/utils/helpers/loadImgSrc';

const appModule = namespace('app');

// TODO: check mb extend ResponsiveImage component instead
@Component({})
export default class CrossfadeResponsiveImage extends Vue {
  @Prop() private media!: ResponsiveImageMedia;
  @Prop() private alt!: string;
  @Prop({ default: false }) private appearTransition!: boolean;

  @appModule.State private imageMQ!: keyof ResponsiveImageMedia;

  private src = '';
  private currentImageMQ: keyof ResponsiveImageMedia = 'MQ1';

  // Public loading states
  public loaded = false;
  public crashed = false;

  // Event emitters with loading states
  @Emit()
  private loading() {
    this.loaded = false;
    this.crashed = false;

    return;
  }

  @Emit()
  private load() {
    this.loaded = true;

    return;
  }

  @Emit()
  private error() {
    this.crashed = true;

    return;
  }

  // Watchers to load new image-src
  @Watch('media')
  private mediaChanged() {
    this.setSrc();
  }

  @Watch('imageMQ')
  private MQChanged() {
    this.currentImageMQ = this.imageMQ;

    this.setSrc();
  }

  // Image is now in a viewport and we can start loading image-src
  private mounted() {
    this.currentImageMQ = this.imageMQ;

    this.setSrc();
  }

  private async setSrc() {
    if (!this.media) return;

    const src = this.media[this.currentImageMQ];

    this.loading();

    try {
      // Load image-src in background
      await loadImgSrc(src);

      this.src = src;

      this.load();
    } catch {
      this.error();
    }
  }
}
